module.exports = __webpack_public_path__ + "static/media/envelopeContact.6ac16e16.svg";